import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import OtpInput from "react-otp-input";
import "./VerifyOTP.css";
import { useDispatch, useSelector } from "react-redux";
import * as _ser from "../../../_redux/_services/UserManagerSlice";
import { authService } from "../../../api/authApi";
import { updateSnackbar } from "../../../_redux/SnackbarSlice";
import { updateLoader } from "../../../_redux/LoaderSlice";
import MessageBar from "../../../components/SnackBar/MessageBar";
import Loader from "../../../components/Loader/Loader";
import { Button } from "@mui/material";
import { Loginillu } from "../../../Icons/Loginillu";

const VerifyOTP = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const location = useLocation();
  const [otp, setOTP] = useState("");
  const [encryptmail, setEncryptmail] = useState("");
  const emailProps = location.state.email;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showLoader = useSelector((state) => state.Loader.value);
  const showMessage = useSelector((state) => state.Snackbar.message);
  const showMsgType = useSelector((state) => state.Snackbar.type);
  const { data } = useSelector((state) => state.UserManager);
  const [initialSnackbar, setInitialSnackbar] = useState({
    type: "",
    message: "",
  });

  const handleSubmit = async () => {
    if (otp) {
      const passwordPattern = /^\d+$/;
      if (!passwordPattern.test(otp)) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "OTP must contain only numeric characters.",
          }),
        );
        return;
      }

      try {
        dispatch(updateLoader(true));
        dispatch(updateSnackbar(initialSnackbar));

        let randomString = Math.random().toString(36).substring(2, 10);
        const randomPassword = `T${randomString}@`;

        const res = await authService.verifyOtp(
          emailProps,
          otp.trim(),
          randomPassword,
        );
        if (res.code === 200) {
          dispatch(updateLoader(false));
          dispatch(
            updateSnackbar({ type: "success", message: "OTP Verified" }),
          );

          setTimeout(() => {
            navigate("/ats/reset-password", {
              state: { email: emailProps, oldPassword: randomPassword },
            });
            dispatch(_ser.userManagerStartReducer({}));
          }, 3000);
        } else {
          dispatch(updateLoader(false));
          dispatch(
            updateSnackbar({
              type: "error",
              message: res.error.message || "invalid OTP",
            }),
          );
        }
      } catch (error) {
        dispatch(updateLoader(false));
        const errorMessage = error.response?.data?.message || "Invalid OTP";
        dispatch(updateSnackbar({ type: "error", message: errorMessage }));
      }
    } else {
      dispatch(updateSnackbar(initialSnackbar));
      setInitialSnackbar({
        type: "error",
        message: "Enter the OTP sent to your email",
      });
    }
  };

  useEffect(() => {
    if (emailProps) {
      getemail();
    }
  }, [emailProps]);

  const resendOTP = async () => {
    try {
      dispatch(updateLoader(true));
      dispatch(updateSnackbar({ type: "", message: "" }));

      await authService.forgotPassword(emailProps);

      dispatch(updateLoader(false));
      dispatch(
        updateSnackbar({ type: "success", message: "OTP resent successfully" }),
      );
    } catch (error) {
      dispatch(updateLoader(false));
      const errorMessage =
        error.response?.data?.message || "Failed to resend OTP";
      dispatch(updateSnackbar({ type: "error", message: errorMessage }));
    }
  };

  const getemail = () => {
    let mail = emailProps;
    let splitmails = mail.split("@");
    if (splitmails.length > 0) {
      console.log(splitmails[0].length - 1);
      let value =
        splitmails[0].substr(0, 3) +
        "xxxxxx" +
        splitmails[0].substr([splitmails[0].length - 1], 1) +
        "@" +
        splitmails[1];
      setEncryptmail(value);
    }
  };

  const [logoUrl, setLogoUrl] = useState("");
  const [appTheme, setTheme] = useState({});

  const { themeSettings } = useSelector((state) => state.theme);

  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";
  useEffect(() => {
    console.log({ themeSettings });
    if (themeSettings?.logo) {
      setLogoUrl(themeSettings.logo);
    }
  }, [themeSettings]);

  useEffect(() => {
    const storedTheme = localStorage.getItem("themeSettings");
    if (storedTheme) {
      setTheme(JSON.parse(storedTheme));
    }
  }, []);

  return (
    <div className="login-page verify-otp-page">
      <div className="login-page__left-container">
        <img
          src={process.env.PUBLIC_URL + "/assests/img/login-icon-1.svg"}
          height={80}
          width={60}
          alt="HireWing"
          className="login-page__icon-1"
        />
        <img
          src={process.env.PUBLIC_URL + "/assests/img/login-icon-2.svg"}
          height={80}
          width={60}
          alt="HireWing"
          className="login-page__icon-2"
        />
        <img
          src={process.env.PUBLIC_URL + "/assests/img/login-icon-3.svg"}
          height={80}
          width={60}
          alt="HireWing"
          className="login-page__icon-3"
        />
        <img
          src={process.env.PUBLIC_URL + "/assests/img/login-icon-4.svg"}
          height={80}
          width={60}
          alt="HireWing"
          className="login-page__icon-4"
        />
        <img
          src={process.env.PUBLIC_URL + "/assests/img/login-icon-4.svg"}
          height={80}
          width={60}
          alt="HireWing"
          className="login-page__icon-5"
        />
        <div className="login-page__platform-info">
          <div className="login-page__platform-info-logo">
            <img
              src={
                logoUrl
                  ? logoUrl
                  : process.env.PUBLIC_URL + "/assests/img/Hirewing-logo.png"
              }
              alt="Company logo"
              className={logoUrl ? "customLogo" : "hirewingImg"}
            />
          </div>
          <div className="login-page__platform-info-heading">
            AI-Driven Recruitment Platform
          </div>
          <div className="login-page__platform-info-subtext">
            Let HireWing's advanced technology transform the way you recruit,
            making it easier and more efficient to find the perfect match for
            your organization.
          </div>
          <div className="login-page__platform-info-illustration">
            <Loginillu primaryColor={storedTheme?.primaryColor} />
          </div>
        </div>
      </div>
      {showMessage !== "" ? (
        <MessageBar message={showMessage} type={showMsgType} />
      ) : (
        ""
      )}
      {showLoader ? <Loader /> : ""}
      <div className="login-page__right-section">
        <div className="login-page__mobile-section">
          <div className="login-page__mobile-top">
            <div className="login-page__platform-info-logo-mobile">
              <img
                src={process.env.PUBLIC_URL + "/assests/img/Hirewing-logo.png"}
                alt="Hirewing logo"
              />
            </div>
            <div className="login-page__mobile-icons">
              <img
                src={process.env.PUBLIC_URL + "/assests/img/login-icon-1.svg"}
                alt=""
                className="login-page__mobile-icon-sm"
              />
              <img
                src={process.env.PUBLIC_URL + "/assests/img/login-icon-2.svg"}
                alt=""
                className="login-page__mobile-icon-lg"
              />
            </div>
          </div>
          <div className="login-page__platform-info-heading-mobile">
            AI-DRIVEN RECRUITMENT PLATFORM
          </div>
        </div>

        <div className={`login-page__form ${isMobile ? "" : "h600"}`}>
          <div
            className="text-center d-flex flex-column align-items-center"
            style={{ paddingTop: isMobile ? "20px" : "90px" }}
          >
            <p
              style={{
                margin: isMobile ? "20px 14px 16px" : "14px 14px 85px",
                fontSize: isMobile ? "14px" : "16px",
                textAlign: "center",
              }}
            >
              Verification code sent to <br />
              <b>{encryptmail}</b>
            </p>
            <div className="login-page__form-inputs">
              <div className="d-flex justify-content-center text-center">
                <OtpInput
                  value={otp}
                  onChange={setOTP}
                  autoComplete="off"
                  inputStyle={{
                    width: isMobile ? 38 : 42,
                    height: isMobile ? 46 : 52,
                    margin: isMobile ? 4 : 6,
                    fontSize: isMobile ? 18 : 20,
                    boxShadow: "0px 3px 6px #00000029",
                    border: "1px solid #E5E5E5",
                    borderRadius: "10px",
                  }}
                  numInputs={6}
                  separator={""}
                />
              </div>
              <div className="text-center">
                <div className="didntreceive">
                  <p>
                    Didn't receive?{" "}
                    <button className="forgotlink2" onClick={() => resendOTP()}>
                      Resend otp
                    </button>
                  </p>
                </div>
                <div className="btnSection">
                  <Button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn-submitotp-verify btn-submitlogin"
                  >
                    Submit
                  </Button>
                </div>
                <Link to="/ats/login" type="button" className="backtologin">
                  Back to login
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="login-page__mobile-illustration">
          <Loginillu primaryColor={storedTheme?.primaryColor} />
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;
